var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one-bd clearfix"},[_c('router-link',{attrs:{"to":"/wxdataAnalysis"}},[_vm._v("微信账号")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/wbdataAnalysis"}},[_vm._v("微博账号")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/ttdataAnalysis"}},[_vm._v("头条账号")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da29c51c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/dataAnalysis/dataAnalysisMenu.vue
// module id = null
// module chunks = 